import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '~/lib/utils';

const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input ref={ref} className={cn('ui-input', className)} {...props} />
  )
);
Input.displayName = 'Input';

export { Input };
